import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    badgeLabel: 'Pending',
    headline: 'Card request pending',
    subtitle:
      "Your card request has been successfully forwarded to an account admin. Once approved, you'll be able to activate your card here.",
  },
  fr: {
    badgeLabel: 'En attente',
    headline: 'Carte en cours d’approbation',
    subtitle:
      'Votre demande de carte a bien été transmise à un·e admin du compte. Une fois la demande validée, vous pourrez activer votre carte ici.',
  },
} as const);

export default locales;
